/**
 * 20/10/2026 — the picker's catalog for a route test's winner formula and
 * rules, by source: on its own drops the Flow metrics plus SMSWiser's
 * delivery numbers (the drop bags carry both — a route test can be won on
 * Delivered Rate before any visit comes in); on the gateway's stats the
 * Flow metrics only. Mirrors shared `routeTestMetricIds`.
 * For Media Devoted | Created By Ciro Autiero
 */
import { type FlowOptimizerMetricMeta, GATE_METRIC_GROUP_LABELS, ROUTE_TEST_SMSWISER_METRIC_IDS, type RouteTestSource } from '@trafficpulse/shared';

import { HOUR_METRIC_CATALOG } from '../general/hour/formula/hour-metric-catalog';
import { GATE_METRIC_CATALOG } from '../verdicts/card/gate-metric-catalog';

const SMSWISER = new Set(ROUTE_TEST_SMSWISER_METRIC_IDS);

/** The Flow metrics under their own heading, then SMSWiser's — only on the drops source. */
export function routeTestMetricCatalog(source: RouteTestSource): FlowOptimizerMetricMeta[] {
  if (source !== 'drops') return HOUR_METRIC_CATALOG;
  const tracker = HOUR_METRIC_CATALOG.map((m) => ({ ...m, section: GATE_METRIC_GROUP_LABELS.tracker }));
  return [...tracker, ...GATE_METRIC_CATALOG.filter((m) => SMSWISER.has(m.id))];
}
